import { ACTION } from "@common/constants/redux";

export const setSongFilter = (filter) => {
  return (dispatch) => {
    dispatch({
      type: ACTION.SET_SONG_FILTER,
      payload: filter,
    });
  };
};
